import { MIMETYPE_SHAPEFILE } from '@disy/lib/media-type';

import { AbstractDataViewExportAction } from 'cadenza/actions/table/abstract-data-view-export-action';
import type { ExportActionContext } from 'cadenza/workbook/actions/export-actions';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import { isMapFullscreenSidebarModalOpen } from 'cadenza/workbook/ui/map-fullscreen-sidebar-modal/map-fullscreen-sidebar-modal-utils';

import i18n from './export-shapefile-action.properties';

export class ExportShapefileAction extends AbstractDataViewExportAction {
  readonly #dataViewId;
  readonly #actionContext;

  constructor(dataViewId: DataViewId, actionContext: ExportActionContext) {
    super(dataViewId, actionContext, MIMETYPE_SHAPEFILE, {
      label: i18n('action.label'),
      dialogTitle: i18n('dialog.title'),
    });
    this.#dataViewId = dataViewId;
    this.#actionContext = actionContext;
  }

  override async execute() {
    const { ShapefileExportDialog } = await import('cadenza/shapefile-export-dialog/shapefile-export-dialog');
    const dialog = new ShapefileExportDialog(i18n('dialog.title'), this.#dataViewId, this.#actionContext);
    dialog.connectAndShow({ hidePreviousModals: !isMapFullscreenSidebarModalOpen() });
  }

  override get enabledSync() {
    return true;
  }
}
